import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarTodayFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3 9H21V6C21 4.895 20.105 4 19 4H16H8H5C3.895 4 3 4.895 3 6V9Z",
		fill: "#111827"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16 2V4M16 6V4M8 2V4M8 6V4M3 6C3 4.895 3.895 4 5 4H8M3 6V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V6M3 6V9H21V6M21 6C21 4.895 20.105 4 19 4H16M16 4H8",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgCalendarTodayFilled);
export default ForwardRef;
